"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LockOutlined_1 = __importDefault(require("@material-ui/icons/LockOutlined"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const Alphaeon_Patient_Financing_Logo_png_1 = __importDefault(require("images/Alphaeon_Patient_Financing_Logo.png"));
function Header() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "header", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.CREDIT_PORTAL_URL, children: (0, jsx_runtime_1.jsx)("img", { src: Alphaeon_Patient_Financing_Logo_png_1.default, className: "logo", alt: "Logo" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "wizard-header-title", children: [(0, jsx_runtime_1.jsx)(LockOutlined_1.default, {}), "Secure Application"] })] }));
}
exports.default = (0, react_1.memo)(Header);
